import { PlanFlat } from '../../../../domain/plan/PlanFlat';

export enum PlanActionType {
  SET_SELECTED_DAY = `SET_SELECTED_DAY`,
  SEARCH_PLANS_SUCCESS = `SEARCH_PLANS_SUCCESS`,
}

export interface SetSElectedDayAction {
  type: PlanActionType.SET_SELECTED_DAY;
  payload: {
    selectedDay: Date;
  };
}

export interface SearchPlansSuccessAction {
  type: PlanActionType.SEARCH_PLANS_SUCCESS;
  payload: {
    plans: Array<PlanFlat>;
  };
}

export type PlanActions = SetSElectedDayAction | SearchPlansSuccessAction;
